import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const MoreOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M9.5 4.77c.19 0 .35.16.35.35v4.37c0 .19-.16.35-.35.35H5.13c-.19 0-.35-.16-.35-.35V5.13c0-.19.16-.35.35-.35H9.5m0-1.6H5.13c-1.08 0-1.95.87-1.95 1.95V9.5c0 1.08.87 1.95 1.95 1.95H9.5c1.08 0 1.95-.87 1.95-1.95V5.13c0-1.08-.87-1.95-1.95-1.95ZM9.5 14.15c.19 0 .35.16.35.35v4.37c0 .19-.16.35-.35.35H5.13c-.19 0-.35-.16-.35-.35V14.5c0-.19.16-.35.35-.35H9.5Zm0-1.6H5.13c-1.08 0-1.95.87-1.95 1.95v4.37c0 1.08.87 1.95 1.95 1.95H9.5c1.08 0 1.95-.87 1.95-1.95V14.5c0-1.08-.87-1.95-1.95-1.95ZM18.87 4.77c.19 0 .35.16.35.35v4.37c0 .19-.16.35-.35.35H14.5c-.19 0-.35-.16-.35-.35V5.13c0-.19.16-.35.35-.35h4.37m0-1.6H14.5c-1.08 0-1.95.87-1.95 1.95V9.5c0 1.08.87 1.95 1.95 1.95h4.37c1.08 0 1.95-.87 1.95-1.95V5.13c0-1.08-.87-1.95-1.95-1.95ZM18.87 14.15c.19 0 .35.16.35.35v4.37c0 .19-.16.35-.35.35H14.5c-.19 0-.35-.16-.35-.35V14.5c0-.19.16-.35.35-.35h4.37Zm0-1.6H14.5c-1.08 0-1.95.87-1.95 1.95v4.37c0 1.08.87 1.95 1.95 1.95h4.37c1.08 0 1.95-.87 1.95-1.95V14.5c0-1.08-.87-1.95-1.95-1.95Z"
      fill={color}
    />
  </Svg>
)

export default MoreOutlined
